function ContainerFlex(props) {
    return (
        <div className="container-flex">
            <div className="container-fluid">
                {props.children}
            </div>
        </div>
    )
}

export default ContainerFlex;